import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { MailWarning } from 'lucide-react';

/**
 * Shown when the mail provider told us this person's address hard-bounced or
 * reported us as spam.
 *
 * Without it the only symptom is post that quietly stops arriving: the daily
 * digest and the periodic report are filtered out at the source
 * (backend/notifications/preferences.py), and nothing on screen says why. The
 * band is the one place the customer can find out, so it links straight to the
 * settings section where he can check the address.
 *
 * Amber, like the look-along band, and for the same reason: something is wrong
 * but nothing is broken. Not dismissible — there is nothing to dismiss, it goes
 * away when the address works again.
 */
export function MailUndeliverableBanner({ show }: { show: boolean }) {
  const { t } = useTranslation();

  if (!show) return null;

  return (
    <div
      role="status"
      className="flex flex-wrap items-center gap-sm px-lg py-sm
                 bg-tone-warn text-bg-primary text-body-sm font-medium"
    >
      <MailWarning className="h-4 w-4 shrink-0" aria-hidden="true" />
      <span>{t('settings.notifications.undeliverable.banner')}</span>
      <Link to="/settings?s=notifications" className="underline underline-offset-2">
        {t('settings.notifications.undeliverable.action')}
      </Link>
    </div>
  );
}
